import { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as ListCellRenders from "../../../common/list/ListCellRenders";
import {
  audienceUserListRequest,
  exportUsersRequest,
} from "../../../../store/slices/audienceSlice";
import { useMountEffect } from "primereact/hooks";
import List from "../../../common/list";
import DropdownButton from "../../../common/dropDownButton";
import { useIntl } from "react-intl";

const AudienceUserList = ({
  audienceId,
  users,
  requesting,
  action,
  audienceUserListRequest,
  exportUsersRequest,
}) => {
  const intl = useIntl();

  const [query, setQuery] = useState({
    pageNo: 1,
    pageSize: 50,
    sortBy: "asc",
    sortColumn: "firstName",
    namePattern: "",
  });

  useMountEffect(() => {
    audienceUserListRequest({ id: audienceId, data: query });
  });

  useEffect(() => {
    audienceUserListRequest({ id: audienceId, data: query });
  }, [query]);

  const handlePageChange = (pageData) => {
    if (
      query.pageSize !== pageData.rows ||
      query.pageNo !== pageData.page + 1
    ) {
      setQuery({
        ...query,
        pageNo: pageData.page + 1,
        pageSize: pageData.rows,
      });
    }
  };

  const handleOnSortChange = (sortData) => {
    setQuery({
      ...query,
      pageNo: 1,
      sortColumn: sortData.sortField,
      sortBy: sortData.sortOrder === 1 ? "asc" : "desc",
    });
  };

  const exportUsers = (fileType) => {
    exportUsersRequest({
      fileType,
      id: audienceId,
      data: query,
    });
  };

  return (
    <>
      <div style={{ marginBottom: 10 }} className="flex justify-content-end">
        <DropdownButton
          icon="pi pi-download"
          label={intl.formatMessage({ id: "export" })}
          items={[
            {
              label: intl.formatMessage({ id: "excel" }),
              command: () => exportUsers("excel"),
            },
            {
              label: intl.formatMessage({ id: "csv" }),
              command: () => exportUsers("csv"),
            },
            {
              label: intl.formatMessage({ id: "pdf" }),
              command: () => exportUsers("pdf"),
            },
          ]}
        />
      </div>
      <List
        loading={action === "userList" && requesting}
        handlePageChange={handlePageChange}
        handleOnSortChange={handleOnSortChange}
        data={users?.list || []}
        pageQuery={query}
        totalRecords={users?.totalCount || 0}
        selectionMode=""
        columns={[
          {
            field: "firstName",
            header: "name",
            sortable: true,
            body: ListCellRenders.FullNameAndEmail(),
          },
          { field: "role.name", header: "role" },
          {
            field: "designation",
            header: "designation",
            sortable: true,
            body: ListCellRenders.StringData("designation"),
          },
          {
            field: "department",
            header: "department",
            sortable: true,
            body: ListCellRenders.StringData("department"),
          },
        ]}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  users: state?.audiences?.users || {},
  requesting: state?.audiences?.requesting,
  action: state?.audiences?.action,
});

const mapDispatchToProps = (dispatch) => ({
  audienceUserListRequest: (data) => dispatch(audienceUserListRequest(data)),
  exportUsersRequest: (data) => dispatch(exportUsersRequest(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AudienceUserList);
